export default __webpack_public_path__ + "static/media/location-icon.84ca3f34.png";